import { data, PartieMachineNodeAugmented } from './../reducer/data.reducer';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { NgxXml2jsonService } from 'ngx-xml2json';
import { EMPTY } from 'rxjs';
import { map, catchError, exhaustMap } from 'rxjs/operators';
import { PartsService } from '../../services/parts.service';
import { isDataLoadingCompleted, updateEndPageNumber, updateStartPageNumber } from '../actions/config.actions';
import { loadData, updateData } from '../actions/data.actions';
import { DATA, INITIAL_DATA } from '../reducer/data.reducer';

@Injectable()
export class DataEffects {
  loadData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadData),
      exhaustMap((data) =>
        this.partsService.loadXMLAndParse(data.uid).pipe(
          map((response: INITIAL_DATA) => {
            const data = response.doc43.partie_machine
              .map((d) => {
                if (d.page) {
                  d.page = d.page.filter((p) => p['@attributes'] && p['@attributes']['numpage']);
                }
                return d;
              })
              .filter((d) => Array.isArray(d.page) && d.page.length)
              .map((d, index) => {
                if (index === 0) {
                  this.store.dispatch(updateStartPageNumber(Number(d['page'][0]['@attributes']['numpage'])));
                } else {
                  this.store.dispatch(
                    updateEndPageNumber(Number(d['page'][d['page'].length - 1]['@attributes']['numpage']))
                  );
                }
                return {
                  ...d,
                  visible: false
                } as PartieMachineNodeAugmented;
              });
            this.store.dispatch(
              isDataLoadingCompleted({
                success: true,
                progress: false
              })
            );
            return updateData(data);
          }),
          catchError((error) => {
            console.error(error);
            updateData([]);
            this.store.dispatch(isDataLoadingCompleted({ success: false, progress: false }));
            return EMPTY;
          })
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private ngxXml2jsonService: NgxXml2jsonService,
    private partsService: PartsService,
    private store: Store<{ data: DATA }>
  ) {}
}
